import { useEffect, useState } from 'react';
import { IReportingOptions, IlogisticServiceDetails } from '../../../../../types/services';
import { getReportingOptionsLogisticsServices } from '../../../../../services/services';
import { displayErrorNotification } from '../../../../../utils/displayNudosStandardNotifications';
import LogisticServiceOriginDestinationLocation from './LogisticServiceOriginDestinationLocation/LogisticServiceOriginDestinationLocation';
import './LogisticServiceDetailsTab2Locations.scss';

const LogisticServiceDetailsTab2Locations = ({
  logisticServiceData,
  updateDataCallback,
  updateWithoutLoader
}: {
  logisticServiceData: IlogisticServiceDetails;
  updateDataCallback: () => Promise<void>;
  updateWithoutLoader: () => Promise<void>;
}) => {
  const [reportingOptionsList, setReportingOptionsList] = useState<IReportingOptions[]>();

  const cityDestination = logisticServiceData.destinationLocation?.cityId;
  const cityOrigin = logisticServiceData?.originLocation?.cityId;
  const sameCity = cityDestination === cityOrigin;

  const getReportingOptions = async () => {
    try {
      const reportingOptions = await getReportingOptionsLogisticsServices();
      setReportingOptionsList([...reportingOptions]);
    } catch (error) {
      displayErrorNotification();
    }
  };

  useEffect(() => {
    getReportingOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="LogisticServiceDetailsTab2Locations">
      <LogisticServiceOriginDestinationLocation
        location="origin"
        logisticServiceData={logisticServiceData}
        updateDataCallback={updateDataCallback}
        sameCity={sameCity}
        updateWithoutLoader={updateWithoutLoader}
        reportingOptionsList={reportingOptionsList}
      />
      <div className="dividerLine" />
      <LogisticServiceOriginDestinationLocation
        location="destination"
        logisticServiceData={logisticServiceData}
        updateDataCallback={updateDataCallback}
        sameCity={sameCity}
        updateWithoutLoader={updateWithoutLoader}
        reportingOptionsList={reportingOptionsList}
      />
    </div>
  );
};

export default LogisticServiceDetailsTab2Locations;
